import React from 'react';
import Kiosk from '../assets/images/Asset 2.png';

function Features({ features, heading, subheading }) {

  return (
    <section className="py-12 px-4 bg-white mb-16" id="features">
      <div className="container mx-auto max-w-6xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-3">
          {heading}
        </h2>
        <p className="text-gray-700 mb-12 max-w-3xl mx-auto">
          {subheading}
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`${feature.bgColor} rounded-3xl text-left ${index === 0 ? 'md:row-span-2' : ''}`}
            >
              <div className='p-6'>
              <div className="flex justify-start mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-gray-700">{feature.description}</p>
                </div>
              
              
              {feature.image && (
                <div className="mt-4 md:mt-6 lg:mt-8 px-10">
                  <img 
                    src={Kiosk}
                    alt={feature.title} 
                    className="rounded-2xl w-full object-cover"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;